import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../layout/use-page-title.js';

/**
 * Story page: motivation, who Thyme is for, and the origin of the name.
 * @returns {JSX.Element}
 */
export function StoryPage() {
	const { t } = useTranslation();
	usePageTitle('site.story.title', 'site.meta.story.description');

	return (
		<section className="story">
			<h1>{t('site.story.title')}</h1>
			<p className="story-lede">{t('site.story.lede')}</p>
			<div className="story-body">
				<p>{t('site.story.body1')}</p>
				<p>{t('site.story.body2')}</p>
				<p>{t('site.story.body3')}</p>
			</div>
		</section>
	);
}
